import { Group, Text } from "@mantine/core";
import { EntityClientAction, MultiDataMapForm } from "@mcurros2/microm";
import { IconAlertCircle, IconUserPin } from "@tabler/icons-react";
import { Dashboard } from "./Dashboard";

export const ACTVerHistorialVerUbicacion: EntityClientAction = {
    name: 'ACTVerHistorialVerUbicacion',
    label: 'Ver Ubicación',
    title: <Text fw={700}>Ver Ubicación</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalHistorialUbicaciones'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Dashboard;
        const dashboard = new Dashboard(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_datos_geolocation_id.value = selectedKeys![0].c_datos_geolocation_id as unknown as string || '';

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Historial de Ubicaciones</Text></Group>,
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: <MultiDataMapForm
                autoFocus
                formMode="edit"
                key={`mapa-ver-ubicacion-personal-${entity.def.name}`}
                title="Historial de Ubicaciones"
                dataMapView1={{
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialVerUbicacion.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1, longitudRecordIndex: 2,
                    tabLabel: "Historial de Ubicaciones",
                    tabIcon: IconUserPin,
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                }}

                mapHeight="50vh"
            />
        });

        return false;
    }
}